if (!customElements.get("m-collection-list")) {
  class MCollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
        slideInner: ".m-mixed-layout__inner",
      };
      this.classes = {
        grid: 'm:grid',
        hidden: 'm:hidden',
        swiper: 'swiper-container',
        swiperWrapper: 'swiper-wrapper'
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.slider = false;

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.total = this.dataset.total;
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = this.dataset.autoplaySpeed;
      this.paginationType = this.dataset.paginationType;
      this.expanded = this.dataset.expanded === "true";
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";

      this.init();
      document.addEventListener("matchMobile", () => {
        this.init();
      });
      document.addEventListener("unmatchMobile", () => {
        this.init();
      });
    }

    init() {
      if (!this.enableSlider) return;
      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer, slideControls, slideInner } = queryDomNodes(this.selectors, this);

      const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;

      // pega o gap do Liquid (var(--column-gap))
      const container = this.closest('.m-collection-list__container') || this;
      const styles = getComputedStyle(container);
      const gap = parseInt(styles.getPropertyValue('--column-gap')) || 8;

      const items = parseInt(this.items || '4', 10);
      const total = parseInt(this.total || '0', 10);

      this.options = {
        loop: true,
        slidesPerGroup: 1,
        centeredSlides: false,
        autoHeight: true,
        parallax: true,

        // 🔑 sem lacuna: Swiper sabe o gap real
        spaceBetween: gap,

        // 🔑 garante duplicatas suficientes no loop
        loopAdditionalSlides: Math.max(6, items * 2, total),
        loopedSlides: Math.max(items, Math.min(total, 12)),

        // autoplay
        autoplay: this.autoplay ? { delay: parseInt(this.autoplaySpeed) * 1000 } : false,

        // paginação/navegação (inalterado)
        pagination:
          this.paginationType == "fraction"
            ? {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
                type: "fraction",
              }
            : {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
                bulletClass: "m-dot",
                bulletActiveClass: "m-dot--active",
                renderBullet: function (index, className) {
                  return '<span class="' + className + '">' + paginationIcon + "</span>";
                },
              },
        navigation: nextButton || prevButton ? {
          nextEl: nextButton && nextButton,
          prevEl: prevButton && prevButton
        } : false,

        // 🔑 slides por viewport
        slidesPerView: 2, // base
        breakpoints: {
          0:    { slidesPerView: 2.4, spaceBetween: gap }, // 3 no mobile
          480:  { slidesPerView: 2.6, spaceBetween: gap },
          768:  { slidesPerView: Math.max(3, Math.min(items, 6)), spaceBetween: gap },
          1280: {
            slidesPerView: (this.expanded && total > items) ? items + 1 : items,
            spaceBetween: gap
          }
        }
      };

      if (typeof this.slider !== 'object') {
        slideContainer.classList.add(this.classes.swiper);
        slideInner.classList.remove(this.classes.grid);
        slideInner.classList.add(this.classes.swiperWrapper);
        slideControls && slideControls.classList.remove(this.classes.hidden);
        this.slider = new MinimogLibs.Swiper(slideContainer, this.options);
      } else {
        // se já existe, atualiza parâmetros e recalcula
        Object.assign(this.slider.params, this.options);
        this.slider.update();
        this.slider.updateSlides();
        this.slider.updateSlidesClasses();
      }

      // posiciona no início do loop
      this.slider.slideToLoop(0, 0);
    }


    destroySlider() {
      const { slideContainer, slideControls, slideInner } = queryDomNodes(this.selectors, this);

      slideContainer.classList.remove(this.classes.swiper);
      slideInner.classList.remove(this.classes.swiperWrapper);
      slideInner.classList.add(this.classes.grid);
      slideControls && slideControls.classList.add(this.classes.hidden);

      if (typeof this.slider === 'object') {
        this.slider.destroy();
        this.slider = false;
      }
    }
  }

  customElements.define("m-collection-list", MCollectionList);
}
